import { render, staticRenderFns } from "./LayoutWithoutPadding.vue?vue&type=template&id=cfa8380a&"
import script from "./LayoutWithoutPadding.vue?vue&type=script&lang=js&"
export * from "./LayoutWithoutPadding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports